import { NOT_AVAILABLE } from 'utils/constants'

export enum COLUMNS_IDS {
  profileNames = 'revenueSources.profileName.keyword',
  verifiedName = 'entityDetails.name.keyword',
  tin = 'entityDetails.tin',
  reportStatus = 'entityDetails.reportedStatus',
  unreportedRevenue = 'overviewDetails.taxGap',
  reported = 'overviewDetails.reportedRevenue',
  totalRevenue = 'totals.totalRevenue',
  grossProfit = 'totals.grossProfit',
  totalSales = 'totals.documentedSales',
  totalRoyalties = 'totals.documentedRoyalties',
  totalBuys = 'totals.documentedBuys',
  dataSources = 'contactInfo.weblinks',
  activityType = 'overviewDetails.activityType',
  firstActivity = 'totals.firstActivity',
  caseId = 'caseId',
  locations = 'entityDetails.location.keyword',
  cryptoTokenName = 'cryptoTokenName',
  cryptoAmount = 'cryptoAmount',
  cryptoDateAndTime = 'cryptoDateAndTime',
  cryptoGainLossUSD = 'cryptoGainLossUSD',
  cryptoActivityFrom = 'cryptoActivityFrom',
  cryptoActivityTo = 'cryptoActivityTo',
  cryptoTransactionHash = 'cryptoTransactionHash',
  itemType = 'itemType',
  cryptoCostBasisUSD = 'cryptoCostBasisUSD',
  cryptoSellValueUSD = 'cryptoSellValueUSD',
  cryptoChain = 'cryptoChain',
  cryptoActivityType = 'cryptoActivityType',
  cryptoCostBasisItem = 'cryptoCostBasisItem',
  cryptoCostBasisActivityType = 'cryptoCostBasisActivityType',
  cryptoCostBasisDateAndTime = 'cryptoCostBasisDateAndTime',
  costBasisAllocation = 'costBasisAllocation',
  cryptoDirection = 'cryptoDirection',
  cryptoTokenType = 'cryptoTokenType',
  cryptoPurchaseValue = 'cryptoPurchaseValue',
  companyIndustry = 'overviewDetails.industry.keyword',
  companyFounded = 'entityDetails.founded.keyword',
  companyLocations = 'totals.jurisdictions.keyword',
  companyEmployeesLocal = 'totals.employeesLocal',
  companyEmployeesLocalPercent = 'totals.employeesLocalPercent',
  companyEmployeesAbroad = 'totals.employeesAbroad',
  companyEmployeesAbroadPercent = 'totals.employeesAbroadPercent',
  companyExecutivesLocal = 'totals.executivesLocal',
  companyExecutivesLocalPercent = 'totals.executivesLocalPercent',
  nonRnDLocal = 'totals.nonRnDLocal',
  nonRnDLocalPercent = 'totals.nonRnDLocalPercent',
  rndLocal = 'totals.RnDLocal',
  rndLocalPercent = 'totals.RnDLocalPercent',
  localDepartments = 'totals.localDepartments.keyword',
  companyType = 'overviewDetails.companyType.keyword',
  ecommerceDocumentedRevenue = 'totals.documentedRevenue',
  ecommerceEstimatedRevenue = 'totals.estimatedRevenue',
  ecommerceCollectsSalesTax = 'entityDetails.collectsSalesTax',
  ecommerceTotalSoldItems = 'totals.totalItemsSold',
  ecommerceTotalReviews = 'totals.totalReviews',
  ecommerceTaxCollection = 'overviewDetails.cartCheckStatus.keyword',
  ecommerceSellerRegStatus = 'overviewDetails.risk.registrationStatus.keyword',
  ecommerceRiskScore = 'overviewDetails.risk.score',
  ecommerceMagnitudeScore = 'overviewDetails.magnitude.score',
  ecommerceRegistry = 'overviewDetails.registry',
  ecommerceShopCategories = 'overviewDetails.shopsCategories',
  ecommerceAddressNexus = 'overviewDetails.risk.physicalNexus.address',
  ecommerceEmployeesNexus = 'overviewDetails.risk.physicalNexus.employees',
  ecommerceNumberOfShops = 'overviewDetails.magnitude.numberOfShops',
  ecommerceAddresses = 'overviewDetails.registry.addresses',
  websiteRanking = 'overviewDetails.magnitude.rank',
  ecommerceNumberOfEmployees = 'totals.numberOfEmployees',
  ecommerceAvgMonthlyCountryTraffic = 'overviewDetails.magnitude.averageLocalTrafficMonthly',
  ecommerceAvgMonthlyTraffic = 'overviewDetails.magnitude.averageTrafficMonthly',
  influencersTotalMedia = 'totals.totalMedia',
  influencersTotalFollowers = 'totals.totalFollowers',
  activeListings = 'totals.activeListings',
  totalListings = 'totals.totalListings',
  revenueSources = 'revenueSources.keyword',
  serviceProvidersExactRevenue = 'totals.exactRevenue',
  offshoreLinkedEntities = 'overviewDetails.entities',
  offshoreOfficerRole = 'overviewDetails.roles',
  lastActivity = 'overviewDetails.lastActivity',
  addresses = 'contactInfo.addresses',
  zone = 'zone',
  firstActivityOverview = 'overviewDetails.firstActivity',
  attributedRevenue = 'totals.attributedRevenue',
  summary = 'overviewDetails.summary',
  controllingEntities = 'overviewDetails.controllingEntities',
  entityDetailsSiteId = 'entityDetails.siteId.keyword',
  entityDetailsNaicsCdtfa = 'overviewDetails.naicsCdtfa.keyword',
  entityDetailsNaicsIvix = 'overviewDetails.naicsIvix.keyword',
  aggregatedTotalsFirstActivity = 'aggregatedTotals.first_activity',
  accountName = 'overviewDetails.accountName.keyword',
  customerName = 'overviewDetails.customerName.keyword',
  accountId = 'overviewDetails.accountId.keyword',
  qtrYieldIvix = 'aggregatedTotals.qtr_yield_ivix',
  salesTaxesDue = 'aggregatedTotals.sales_taxes_due',
  businessType = 'overviewDetails.accountType.keyword',
  siteStartDate = 'aggregatedTotals.site_start_date',
  siteEndDate = 'aggregatedTotals.site_end_date',
  numYearsWithQtrYield = 'aggregatedTotals.num_years_with_qtr_yield',
  totalAdjustedOfTotalDue = 'aggregatedTotals.total_adjusted_of_total_due',
  siteStatus = 'aggregatedTotals.site_status.keyword',
  businessName = 'entityDetails.name',
  businessReportedStatus = 'reportedStatus',
  businessDataSources = 'dataSources',
  businessStructure = 'businessStructure',
  businessIndustry = 'businessIndustry',
  businessAddress = 'businessAddress',
  businessOwners = 'businessOwners',
  businessTin = 'businessTin',
  businessLocations = 'businessLocations',
  businessEmployees = 'businessEmployees',
  businessMarketingEfforts = 'businessMarketingEfforts',
  businessDocumentedIncome = 'businessDocumentedIncome',
  businessReportedIncome = 'businessReportedIncome',
  businessNumberOfReviews = 'businessNumberOfReviews',
  businessNumberOfVisitors = 'businessNumberOfVisitors',
  businessUntaxedIncome = 'businessUntaxedIncome',
  hostName = 'totals.hostName',
}

export const handlePercentCell = (value: number, toFixed = 1) => {
  return value !== undefined && value !== null ? `${(value * 100).toFixed(toFixed)}%` : NOT_AVAILABLE
}

export const LOCAL_DEPARTMENTS_COUNT = 1
